<template>
  <v-snackbar v-model="state.visible" :color="state.color" timeout="4000">
    <div class="d-flex align-center">
      <v-icon class="mr-2" :size="24">{{ state.icon }}</v-icon>
      <span>{{ state.message }}</span>
    </div>
  </v-snackbar>
</template>

<script setup>
import { inject } from "vue";

// Inject the toast state
const toast = inject("toast");
const state = toast.getState(); // Bind to the reactive state
</script>
